import { persistReducer } from "redux-persist"
import { PersistConfig } from "redux-persist/es/types"
import storage from "redux-persist/lib/storage"

import BehaviorTable, {
  IInitialBehaviorTableState,
} from "~/store/behavior-table/BehaviorTable"
import bolManagementReducer from "~/features/bol/state"
import CommonReducer from "~/store/common/commonSlice"
import contractManagementReducer from "~/features/contracts/model/state"
import cargoReducer from "~/features/cargo/state"
import UserReducer from "~/store/user/userSlice"
import cargoOwnersReducer from "~/features/cargo-owners/model/state"

const commonPersistConfig: PersistConfig<any> = {
  key: "common",
  version: 1,
  storage,
}
const userPersistConfig: PersistConfig<any> = {
  key: "user",
  version: 1,
  storage,
}

const behaviorTablePersistConfig: PersistConfig<IInitialBehaviorTableState> = {
  key: "behavior-table",
  version: 1,
  storage,
}

const persistedCommon = persistReducer(commonPersistConfig, CommonReducer)
const persistedUser = persistReducer(userPersistConfig, UserReducer)
const persistedBehaviorTable = persistReducer(
  behaviorTablePersistConfig,
  BehaviorTable,
)

export const combinedReducers = {
  common: persistedCommon,
  user: persistedUser,
  cargo: cargoReducer,
  behaviorTable: persistedBehaviorTable,
  bolManagement: bolManagementReducer,
  contractManagement: contractManagementReducer,
  cargoOwners: cargoOwnersReducer,
}
